import { fontSizes } from '../../../../constants/constants';
import dynamicfunction from '../../../../utils/dynamicfunction';
import { ErrorText, RadioButton, RowView, Text } from '../index';

const ExemptEntityThen = ({
  getContent,
  values,
  setFieldValue,
  setFieldError,
  setFieldTouched,
  touched,
  optionsYesOrNO,
  errors,
}) => {
  const { TextWeight } = dynamicfunction();

  return (
    <>
      <div className='pt-3 sm:pt-5'>
        <Text
          text={getContent('if_exempt_entity_then')}
          size={fontSizes.h18}
          isTruncate={false}
          weight={TextWeight.medium}
          className='block'
          isRequired={true}
        />
      </div>
      <RowView className='pt-3 sm:pt-5' isResponsive>
        <div className='w-full'>
          <RadioButton
            label={getContent('are_you_exempt_benefiacial_owner')}
            value={values?.exemptBeneficialOwner}
            onChange={(e) => {
              setFieldValue('exemptBeneficialOwner', e);
              setFieldTouched('exemptBeneficialOwner', false);
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText text={getContent(touched?.exemptBeneficialOwner ? errors?.exemptBeneficialOwner : '')} />
        </div>
      </RowView>
      <RowView className='pt-3 sm:pt-5' isResponsive>
        <div className='w-full'>
          <RadioButton
            label={getContent('governmental_entity_or_owned_agency')}
            value={values?.governmentalEntityForExemptEntities}
            onChange={(e) => {
              setFieldValue('governmentalEntityForExemptEntities', e);
              setFieldTouched('governmentalEntityForExemptEntities', false);
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText
            text={getContent(touched?.governmentalEntityForExemptEntities ? errors?.governmentalEntityForExemptEntities : '')}
          />
        </div>
      </RowView>
      <RowView className='pt-3 sm:pt-5' isResponsive>
        <div className='w-full'>
          <RadioButton
            label={getContent('central_bank_of_issue')}
            value={values?.centralBankOfIssueForExemptEntities}
            onChange={(e) => {
              setFieldValue('centralBankOfIssueForExemptEntities', e);
              setFieldTouched('centralBankOfIssueForExemptEntities', false);
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText
            text={getContent(touched?.centralBankOfIssueForExemptEntities ? errors?.centralBankOfIssueForExemptEntities : '')}
          />
        </div>
      </RowView>
      <RowView className='pt-3 sm:pt-5' isResponsive>
        <div className='w-full'>
          <RadioButton
            label={getContent('international_organization_or_owned_agency')}
            value={values?.internationalOrganizationForExemptEntities}
            onChange={(e) => {
              setFieldValue('internationalOrganizationForExemptEntities', e);
              setFieldTouched('internationalOrganizationForExemptEntities', false);
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText
            text={getContent(
              touched?.internationalOrganizationForExemptEntities ? errors?.internationalOrganizationForExemptEntities : ''
            )}
          />
        </div>
      </RowView>
      <RowView className='pt-3 sm:pt-5' isResponsive>
        <div className='w-full'>
          <RadioButton
            label={getContent('non_reporting_ffi_please_provide')}
            value={values?.nonReportingFfiForExemptEntities}
            onChange={(e) => {
              setFieldValue(
                'nonReportingFfiForExemptEntities',
                e
              );
              setFieldTouched(
                'nonReportingFfiForExemptEntities',
                false
              );
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText
            text={getContent(
              touched?.nonReportingFfiForExemptEntities ? errors?.nonReportingFfiForExemptEntities : ''
            )}
          />
        </div>
        <div className='w-full'>
          <RadioButton
            label={getContent('investment_entity_owned_by_exempt')}
            value={values?.investmentEntityWhollyOwnedByExemptBeneficialOwners}
            onChange={(e) => {
              setFieldValue('investmentEntityWhollyOwnedByExemptBeneficialOwners', e);
              setFieldTouched('investmentEntityWhollyOwnedByExemptBeneficialOwners', false);
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText
            text={getContent(touched?.investmentEntityWhollyOwnedByExemptBeneficialOwners ? errors?.investmentEntityWhollyOwnedByExemptBeneficialOwners : '')}
          />
        </div>
        <div className='lg:w-full hidden lg:block'></div>
      </RowView>
    </>
  );
};
export default ExemptEntityThen;
